<textarea #textArea class="form-control" [rows]="rows" id="detailsComment" [maxlength]="maxLength"
  placeholder="Description" required [(ngModel)]="sourceText" [disabled]="disabled" (change)="textChanged()"
  (keyup)="capitalizeFirstletter()"></textarea>
<a *ngIf="sourceText?.length>80" #toggleButtonDetails id="toggleButtonDetails"
  (click)="toggleText(textArea,sourceText,$event)" href="javascript:void(0);">See
  More</a>
